import { useTranslation } from "react-i18next";
import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import { useState } from "react";
import { Label } from "../../../../../../shared/components/label/Label";
import { Input } from "../../../../../../shared/components/input/Input";

const CreateSubgoalForm = ({ onSubmitHandler, parentGoal, selectables }) => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    dimensionName: yup
      .string()
      .required(
        t("objectivesTracker.createSubgoalForm.fields.dimensionName.required"),
      ),
    dimensionId: yup
      .string()
      .required(
        t("objectivesTracker.createSubgoalForm.fields.dimensionId.required"),
      ),
  });

  const defaultValues = {
    dimensionId: "",
    dimensionName: "",
    dimensionLabel: "",
    dimensionValue: "",
  };

  const [dimensions, _] = useState(
    selectables?.map((s) => {
      return { value: s.dimension.value, label: t(s.dimension.label) };
    }),
  );
  const [dimensionValues, setDimensionValues] = useState([]);

  const [dimensionLabel, setDimensionLabel] = useState();
  const [dimensionValue, setDimensionValue] = useState();

  const onDimensionChangeValue = (value) => {
    setDimensionValues(
      selectables?.filter((s) => s.dimension.value === value)[0].values,
    );
    setDimensionLabel(
      t(
        selectables?.filter((s) => s.dimension.value === value)[0].dimension
          .label,
      ),
    );
  };

  const onDimensionValuesChangeValue = (value) => {
    setDimensionValue(
      dimensionValues.filter((dv) => dv.value === value)[0].label,
    );
  };

  const [ratio, setRatio] = useState(100);
  const [goal, setGoal] = useState(parentGoal);

  const onGoalChangeHandler = (e) => {
    const goalToReachValue = +e.target.value;
    const ratioToReachValue = (goalToReachValue / parentGoal) * 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onRatioChangeHandler = (e) => {
    const ratioToReachValue = +e.target.value;
    const goalToReachValue = (parentGoal * ratioToReachValue) / 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onSubmit = (formValues) => {
    onSubmitHandler({
      ...formValues,
      dimensionValue: dimensionValue,
      dimensionLabel: dimensionLabel,
      ratio: ratio,
    });
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmit}
    >
      <FormSelect
        name="dimensionName"
        label={t(
          "objectivesTracker.createSubgoalForm.fields.dimensionName.label",
        )}
        options={dimensions}
        placeholder={t(
          "objectivesTracker.createSubgoalForm.fields.dimensionName.placeholder",
        )}
        onValueChangeHandler={onDimensionChangeValue}
        required
      />
      <FormSelect
        name="dimensionId"
        label={t(
          "objectivesTracker.createSubgoalForm.fields.dimensionId.label",
        )}
        options={dimensionValues}
        placeholder={t(
          "objectivesTracker.createSubgoalForm.fields.dimensionId.placeholder",
        )}
        onValueChangeHandler={onDimensionValuesChangeValue}
        required
      />
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.createSubgoalForm.fields.goal.label")}
          </Label>
          <Input type="number" onChange={onGoalChangeHandler} value={goal} />
        </div>
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.createSubgoalForm.fields.ratio.label")}
          </Label>
          <Input type="number" onChange={onRatioChangeHandler} value={ratio} />
        </div>
      </div>
    </BaseForm>
  );
};

export default CreateSubgoalForm;
